import React, { Suspense, useEffect, useState, useRef } from 'react'
import WpAPI from '../../WpApi';
import { Redirect } from 'react-router';
import { CHOOSE_COLOR, CREATE_RESUME, DASHBOARD_LINK, FINAL_RESUME, HEADING_LINK, BREADCRUMB_LINKS, SITE_DOMAIN, APP_DOMAIN, POPUP_TYPES, COOKIE_DOMAIN, PAID_SERVICES, MEMBERSHIP, QUICK_EDITOR, REVIEW_HEADING_LINK, REVIEW_LANDINGPAGE_LINK, COVERLETTER_EXPERIENCE } from '../../constants/constants';
import Cookie from 'js-cookie';
import { connect, useDispatch } from 'react-redux';
import {
  loadResume,
  saveResume,
  duplicateResume as duplicateResumeAction,
  PREVIEW_RESUME,
  userCompletesSectionsDownloadsPrintsOrShares as userCompletesSectionsDownloadsPrintsOrSharesAction,
  setResumeFormat,
  resumeReview
} from '../../services/actions/actions';
import '../../assets/scss/app/blocks/dashboard.scss';
import downloadResume from '../../downloadResume';
import Resumes from '../resumetemplates/Resumes';
import PageLoader from '../common/PageLoader';
// import ArrowBtn from '../../images/btn-arrow.svg';
import { usePopup } from '../../context/PopupContext';
import SignUpPopup from '../user/SignUpPopup';
import { useHistory, useLocation } from 'react-router-dom';
import Splash from '../common/Splash';
// import AiBanner from './common/AiBanner';
import { getDateForDisplay, stringElipse, removeBodyScroll, circleColor } from '../../helper';
import { useUser } from '../../context/UserContext';
import 'react-circular-progressbar/dist/styles.css';
import ResumeReviewComponent from './ResumeReviewComponent';
import { getResumeName } from '../../helper';
import { prevent } from '../common/Prevent';
import { NoResumeFound } from './NoResumeFound';
import { PDFHeaderFooter } from '../PDFHeaderFooter';
import { canProceedWithResumeAction } from '../../utils/resumeLimitCheck';

const ResumesListing = (props) => {
  const entityName = "Resume";
  const entityType = "resume"
  const reactHistory = useHistory();
  const confirmbox = usePopup();
  const location = useLocation();
  const [entities, setEntities] = useState('')//Always keep default value as '', used in code
  const [currentEntity, setCurrentEntity] = useState('');
  const [spinner, setSpinner] = useState(false)
  const [createAction, setCreateAction] = useState(false)
  const [editAction, setEditAction] = useState('')
  const [singleEntity, setSingleEntity] = useState('')
  const [renameEntity, setRenameEntityBox] = useState(false)
  const [newName, setNewName] = useState('')
  const [error, setError] = useState([])
  const [buttonList, setButtonList] = useState('');
  const entityRef = useRef("");
  const oneTimeSortRef = useRef();
  const [entityLink, setEntityLink] = useState(false)
  const [singleItemHeight, setSingleItemHeight] = useState('100%');
  const [singleItemWidth, setSingleItemWidth] = useState("auto");
  const [showLoginPopUp, setShowLoginPopUp] = useState(false)
  const [loader, setLoader] = useState({ download: false, save: false, share: false });
  const [reload, setReload] = useState(false);
  const [mobileDevice, setMobileDevice] = useState('');
  //State to maintain loader in case review takes time
  const [reviewLoader, setReviewLoader] = useState([])

  const [resumeLoader, setResumeLoader] = useState(true);
  const [showcasePopup, setShowcasePopup] = useState(false);
  const [showcaseEmail, setShowcaseEmail] = useState('');
  const [showcaseStatus, setShowcaseStatus] = useState(null);
  const [showcaseLoading, setShowcaseLoading] = useState(false);
  const errorStyle = { color: 'red', fontSize: '10px' }
  const {
    checkMembership,
    plan,
    user
  } = useUser();

  const mounted = useRef(false);

  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);

  useEffect(()=>{
    //First time
      setMobileDevice(window.innerWidth > 769 ? false : true );
      //every second time
      function handleResize() {
          setMobileDevice(window.innerWidth > 769 ? false : true );
      }
      window.addEventListener('resize', handleResize);
  // Remove the event listener when the component unmounts
  return () => {
    window.removeEventListener('resize', handleResize);
  };
  },[])

  const [openRows, setOpenRows] = useState({});
  const handleToggle = (key) => {
    setOpenRows((prevState) => ({
      ...prevState,
      [key]: !prevState[key] || false,
    }));
  };
  // const handleToggle = (key) => {
  //   setOpenRows((prevState) => {
  //     const isOpen = prevState[key];
  //     const updatedState = isOpen
  //       ? { ...prevState, [key]: false }
  //       : { [key]: true };
  //     const updatedFirstRowKey = isOpen ? null : key;
  //     setFirstRowKey(updatedFirstRowKey);
  //     return updatedState;
  //   });
  // };

  //set dashboard_tab
  useEffect(() => {
    Cookie.set('dashboard_tab', 'resume', {domain: COOKIE_DOMAIN, path: "/"});
  }, []);

  // Manage button list click on short size of template

  const dispatch = useDispatch()
  let entityNames = [];

  // Set Reumes Scaling Logic
  const scalingAreaElements = useRef([]);
  const observer = useRef(null);

  const changeScale = () => {
    const elements = scalingAreaElements.current;

    if (elements.length > 0) {
      const resumeContainer = document.getElementsByClassName('resume-container')[0];
      if (!resumeContainer) {
        console.warn('changeScale: .resume-container not found');
        return;
      }

      const width = resumeContainer.offsetWidth;
      if (!width || width === 0) {
        console.warn('changeScale: resume-container has invalid offsetWidth');
        return;
      }

      const scale = width / 641;
      
      // Use requestAnimationFrame to prevent ResizeObserver loops
      requestAnimationFrame(() => {
        for (let i = 0; i < elements.length; i++) {
          const element = elements[i];
          if (element && element.style) {
            element.style.transform = `scale(${scale})`;
            // Force a reflow to prevent layout thrashing
            element.offsetHeight;
          }
        }
      });
    }
  };

  useEffect(() => {
    const observerCallback = (mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          scalingAreaElements.current = Array.from(
            document.querySelectorAll('.single-template .scaling-area')
          );
          //changeScale();
        }
      }
    };

    const options = { childList: true, subtree: true };
    observer.current = new MutationObserver(observerCallback);
    observer.current.observe(document.body, options);

    return () => {
      if (observer.current) {
        observer.current.disconnect();
      }
    };
  }, []);

  useEffect(() => {
    scalingAreaElements.current = Array.from(
      document.querySelectorAll('.single-template .scaling-area')
    );
    changeScale();
    // Set Scaling when device orientation changes
    let portrait = window.matchMedia("(orientation: portrait)");
    portrait.addEventListener("change", function(e) {
        if(e.matches) {
            // Portrait mode
            changeScale();
        } else {
          // Landscape Mode
          changeScale();
        }
    })
  }, []);

  const editEntity = (key, editorType) => {
    dispatch(loadResume(key)).then(res => {
      const tabs = res.resume.enabled_tabs;
      let edit_action = (
        tabs.length > 1 //User should move ahead of first section
          ? (
            //Incompleted resume should land to ALLINONE
            (WpAPI.isLoggedIn() && plan == 'pro' && tabs.indexOf('completed') == -1) ? QUICK_EDITOR : FINAL_RESUME
          ) : HEADING_LINK
      );
      setEditAction(edit_action);
    })
  }

  const deleteEntity = key => {
    WpAPI.deleteResume(key)
    let r = { ...entities }
    delete r[key]
    setEntities(r);
    props.setResumeCount(Object.keys(r).length);
    setTimeout(() => {
      if (!Object.keys(r).length) {
        let loader = document.querySelector('.page-loader');
        if (loader != null) {
          loader.style.display = 'none';
        }
      }
    }, 200);
  }

  const duplicateEntity = key => {
    dispatch(duplicateResumeAction(key, '', 'list')).then(res => {
      let entities = JSON.parse(JSON.stringify(res))
      setEntities(entities);
    }).catch(err => {
      console.log('Duplicate failed:', err);
    })
  }
  const onClickOutside = React.useCallback((e) => {
    if (e.target.classList.value != 'single-template')
      setButtonList('');
  }, []);
  useEffect(() => {
    const handleClickOutside = (e) => {
      // If entity has been deleted then current reference is not found. So, we have to add a null condition.
      if ((entityRef.current && !entityRef.current.contains(e.target)) || entityRef.current == null) {
        onClickOutside && onClickOutside(e);
      }
    };
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [onClickOutside]);

  useEffect(() => {
    confirmbox.configurePopup(POPUP_TYPES);
  }, []);

  useEffect(() => {
    if (entities === '') { // Only fetch data if it's not already loaded
        WpAPI.loadResumesInDashboard(setEntities);
    }
    if (currentEntity === '') {
        let cr = WpAPI.getCurrentResume();
        setCurrentEntity(cr);
    }
  //   setTimeout(() => {
  //     if (!Object.keys(entities).length) {
  //       setResumeLoader(false); // Hide loader if data is empty
  //     } 
  // }, 1000);

}, []);

useEffect(() => {//this will review the latest resume
  // Fix: Sentry issue RESUMEORG-REACT-1C - Add robust entity validation
  if (entities && typeof entities === 'object' && !Array.isArray(entities) && Object.keys(entities).length && !oneTimeSortRef.current){
    const first = sortDashboardEntities(entities)[0]
    sendToReviewIf(first)
    oneTimeSortRef.current = first

    setOpenRows({ [first]: true }); 
  }
}, [entities]);

  useEffect(() => {
    if (props.showcaseRef) props.showcaseRef.current = openShowcasePopup;
  });

  if (createAction) {
    history.pushState(null, DASHBOARD_LINK);
    return <Redirect to={CHOOSE_COLOR} />
  }
  if (editAction.length) {
    history.pushState(null, DASHBOARD_LINK);
    return <Redirect to={editAction} />
  }
  const sortDashboardEntities = (_entities) => {
    // Fix: Sentry issue RESUMEORG-REACT-1C - Handle null/undefined/non-object entities
    if (!_entities || typeof _entities !== 'object' || Array.isArray(_entities)) {
      return [];
    }
    
    return Object.keys(_entities).sort((x, y) => {
      if (_entities[x].hasOwnProperty('modified_date') && _entities[y].hasOwnProperty('modified_date')) {
        return (new Date(_entities[x].modified_date)).getTime() - (new Date(_entities[y].modified_date)).getTime()
      } else if (_entities[x].hasOwnProperty('modified_date') && !_entities[y].hasOwnProperty('modified_date')) {
        return (new Date(_entities[x].modified_date)).getTime() - (new Date('1947-01-01')).getTime()
      } else if (!_entities[x].hasOwnProperty('modified_date') && _entities[y].hasOwnProperty('modified_date')) {
        return (new Date('1947-01-01')).getTime() - (new Date(_entities[y].modified_date)).getTime()
      } else if (entities[x].hasOwnProperty('created_date') && _entities[y].hasOwnProperty('created_date')) {
        return (new Date(_entities[x].created_date)).getTime() - (new Date(_entities[y].created_date)).getTime()
      }
    }).reverse()
  }
  const dashboardEntities = sortDashboardEntities(entities);

  const checkEntityCount = (entities) => {
    // Fix: Sentry issue RESUMEORG-REACT-1C - Handle null/undefined/non-object entities
    if (!entities || typeof entities !== 'object' || Array.isArray(entities)) {
      return 0;
    }
    return Object.keys(entities).length;
  }

  const downloadHandle = (entity, type) => {
    setSpinner(true);
    downloadResume(entity, () => {
      setSpinner(false);
      gaTrack('RB App', 'Dashboard', `Download ${entityName}`);
      ga4Track(`app_dashboard_download_${entityType}`, 'RB App', `Download ${entityName}`);
    }, 'pdf');
  }

  const downloadHandler = (key, downloadFormat) => {
    downloadResume({[entityType]: {...entities[key], id: key}, user: props.user}, user, () => { 
      confirmbox.close('download') 
      setTimeout(() => {
        confirmbox.show('askfor_trustpilot_review', null, () => {
          window.open( `https://www.trustpilot.com/review/resume.org`, '_blank');
        });
      }, 3000); 
    }, downloadFormat, {type: entityType, name: entityName });
  }

  const userCompletesSectionsDownloadsPrintsOrShares = (entity) => {
    dispatch(userCompletesSectionsDownloadsPrintsOrSharesAction({ ...entity }, 'list')).then(res => {
      if (res.completed) {
        const ec = (PAID_SERVICES && plan == 'pro' ? 'app_editor_finalizations' : 'app_editor_finalizations_free');
        const el = (
            PAID_SERVICES && plan == 'pro' 
            ? 'User completes sections: Downloads, Prints or Shares' 
            : 'Free user completes sections: tries to download, print, share'
        );
        ga4Track(ec, 'RB App', el)
      }
    })
  }

  const download = (params) => {
    localStorage.setItem('clickAction', 'download');
    if(WpAPI.isLoggedIn()){
        localStorage.setItem(`${entityName}Name`, params.rname);
        confirmbox.show('download', null, (popupParams) => {
            downloadHandler(params.key, popupParams.downloadFormat); 
            userCompletesSectionsDownloadsPrintsOrShares(params.resume); 
            gaTrack('RB App', 'Dashboard', `Download ${entityName}`)
            ga4Track(`app_dashboard_download_${entityType}`, 'RB App', `Download ${entityName}`);
        }, {plan: plan, entity:{type: entityType, name: entityName }, referrer:'dashboard'});
      ga4Track(`app_my_${entityType}s_download`, 'RB App', `My ${entityName}s: Download`);
    } else {
      setShowLoginPopUp(true);
      Cookie.set('redirect_to', location.pathname, { domain: COOKIE_DOMAIN, path: "/" });
    }
  }

  const share = (params) => {
    if (WpAPI.isLoggedIn()) {
      if (PAID_SERVICES) {
        if (plan == 'pro') {
          confirmbox.show('share', null, () => {
            gaTrack('RB App', 'Dashboard', `Share ${entityName}`)
            ga4Track(`app_dashboard_share_${entityType}`, 'RB App', `Share ${entityName}`);
          }, { [entityType]: { ...params.resume, id: params.key }, user: props.user, type: 'list', entity: { type: entityType, name: entityName } })
        } else {
          reactHistory.push(MEMBERSHIP)
        }
      } else {
        confirmbox.show('share', null, () => {
          gaTrack('RB App', 'Dashboard', `Share ${entityName}`)
          ga4Track(`app_dashboard_share_${entityType}`, 'RB App', `Share ${entityName}`);
        }, { [entityType]: { ...params.resume, id: key }, user: props.user, type: 'list', entity: { type: entityType, name: entityName } })
      }
      ga4Track(`app_my_${entityType}s_share_a_link`, 'RB App', `My ${entityName}s: Share a Link`);
      userCompletesSectionsDownloadsPrintsOrShares(params.resume);
    } else {
      setShowLoginPopUp(true);
      Cookie.set('redirect_to', location.pathname, { domain: COOKIE_DOMAIN, path: "/" });
    }
  }

  const checkMembershipAction = (callback = false, params = false) => {
    if (typeof callback == 'function' && mounted.current) setLoader({ ...loader, [callback.name]: true });
    checkMembership(() => {
      if (typeof callback == 'function') {
        callback(params);
        if (mounted.current) setLoader({ ...loader, [callback.name]: false });
      }
    });
  }
  const sendToReviewIf = (id) => {
    if(entities !== ''){
        const _r = entities[id]
        const _review_time = _r?.resume_reviewed_time
        const _m_time = _r?.modified_date
        //Must have created date atleast
        const _c_time = _r?.created_date
        // console.log( (new Date(_review_time > new Date(_m_time))))
        if(_review_time && _m_time  && (new Date(_review_time) > new Date(_m_time))){
          //All good, last updated 
        }else if(_c_time) sendToReview(id)
    }
  }
  const sendToReview = (id)=> {
     //Show loader before sending review request
     reviewLoader.push(id)
     setReviewLoader(reviewLoader)
     dispatch(loadResume(id)).then(res => {//First fetch resume data
       dispatch(resumeReview(null, true, id)).then(res1 => {//Second reviw it
        let _e = {...entities}
        _e[id].resume_review = res1;
         //Set into main object
         setEntities(_e);
         //This will reload the page to reflect review changes
         setReload(!reload)
         //Unset loader
         reviewLoader.pop(id)
         setReviewLoader(reviewLoader)
       })
     })
  }
  const ReviewLinkComponent = ({ id, hasScore, score }) => <a className="text-decoration-none"
    onClick={() => {
      // reviewLoader.includes(id)
      if (hasScore) {
        if (WpAPI.isLoggedIn()) {
          if (plan == 'pro') {//Membership
            Cookie.set('current_resume', id, { domain: COOKIE_DOMAIN, path: '/' });
            // window.location.href = REVIEW_LANDINGPAGE_LINK;
            setEditAction(REVIEW_LANDINGPAGE_LINK)
          } else {//Ask for payment
            // localStorage.setItem('clickAction', 'review_request');
            Cookie.set('current_resume', id, { domain: COOKIE_DOMAIN, path: '/' });
            Cookie.set('redirect_to', REVIEW_LANDINGPAGE_LINK, { domain: COOKIE_DOMAIN, path: "/" });
            window.location.href = MEMBERSHIP;
          }
        } else {//Ask for login
          //redirect
          setShowLoginPopUp(true);
          localStorage.setItem('clickAction', 'review_request');
          Cookie.set('current_resume', id, { domain: COOKIE_DOMAIN, path: '/' });
          Cookie.set('redirect_to', REVIEW_LANDINGPAGE_LINK, { domain: COOKIE_DOMAIN, path: "/" });
        }
      } else {//No matter review it, if not done
        sendToReview(id)
      }
    }}
  >
    <div className={`reveiw-btn ${hasScore ? 'fix' : 'review'}`}>
      <span>{hasScore ? (score =='100' ? 'Check Again' : 'Fix Now') : (reviewLoader.includes(id) ? 'Loading...' : 'Review Now')} <i className="icon-right-arrow"></i></span>
    </div>
  </a>
const ActionGroupOne = ({entity ,keyValue, rname, showLabel})=>{
  const btnClassName = showLabel ? 'action-btn' : 'action-btton';
    return <div className={btnClassName}>
        <div className='btn-combo'>
        <span onClick={() => {
            editEntity(keyValue, entity.active_editor);
            gaTrack('RB App', 'Dashboard', `Edit ${entityName} Icon`)
            ga4Track(`app_dashboard_edit_${entityType}_icon`, 'RB App', `Edit ${entityName} Icon`);
          }}><img src={`${APP_DOMAIN}/assets/images/edit-icon2.svg`} />
          {(mobileDevice || showLabel) && <span className='action_edit'>Edit</span>}
        </span>
      <span onClick={() => checkMembershipAction(download, { [entityType]: entity, key: keyValue, rname: rname })}><img src={`${APP_DOMAIN}/assets/images/download-icon2.svg`} />
      {(mobileDevice || showLabel) && <span className='action_download'>Download</span>}
      </span>
      </div>
      {showLabel ? <span className='toggel-btn' onClick={() => handleToggle(keyValue)}>
        <i className={`icon-arrow-${openRows[keyValue] ? 'up' : 'down'}-light`}></i>
      </span> : ''}
  </div>
}
const ActionGroupTwo = ({entity ,keyValue}) =>{
  return <><div className='template-action-btn'>
  <span onClick={() => {
    duplicateEntity(keyValue);
    gaTrack('RB App', 'Dashboard', `Duplicate ${entityName}`)
    ga4Track(`app_dashboard_duplicate_${entityType}`, 'RB App', `Duplicate ${entityName}`);
  }}>
    <img src={`${APP_DOMAIN}/assets/images/copy-icon2.svg`} /> Duplicate
  </span>
  {(PAID_SERVICES && plan == 'pro') && <span onClick={() => { checkMembershipAction(share, { [entityType]: entity, key: keyValue }) }}> <img src={`${APP_DOMAIN}/assets/images/share-icon2.svg`} /> Share </span>}
  <span onClick={(e) => {
    confirmbox.show('delete', null, () => {
      deleteEntity(keyValue);
      gaTrack('RB App', 'Dashboard', `Delete ${entityName}`);
      ga4Track(`app_dashboard_delete_${entityType}`, 'RB App', `Delete ${entityName}`);
    })
  }}> <img src={`${APP_DOMAIN}/assets/images/trash-icon2.svg`} /> Delete</span>
  {(user?.capabilities?.administrator || user?.capabilities?.editor || user?.capabilities?.author) && <><span onClick={prevent(() => { setEditAction("/admin-options/"+keyValue) })}> Admin Options </span></>}
</div>
</>
}
  const openShowcasePopup = () => {
    setShowcasePopup(true);
    setShowcaseLoading(true);
    setShowcaseStatus(null);
    setShowcaseEmail('');
    WpAPI.checkShowcaseEligible(user.id).then(resp => {
      if (mounted.current) {
        setShowcaseStatus(resp);
        setShowcaseLoading(false);
      }
    }).catch(() => {
      if (mounted.current) {
        setShowcaseStatus({ error: 'Failed to check eligibility' });
        setShowcaseLoading(false);
      }
    });
  };

  const submitShowcaseQueue = () => {
    if (!showcaseStatus?.resume_ids?.length || !showcaseEmail) return;
    setShowcaseLoading(true);

    const items = showcaseStatus.resume_ids.map(rid => {
      const rdata = entities[rid];
      const tpls = PDFHeaderFooter(rdata.active_template, rdata?.active_color, rdata?.custom_template_color, 'resume');
      const fname = rdata?.heading?.fname || '';
      const lname = rdata?.heading?.lname || '';
      return {
        resume_id: rid,
        resume_name: (fname + ' ' + lname).trim(),
        header: tpls.h,
        header1: tpls.h1,
        footer: tpls.f,
        showcase_label: rdata.showcase_label || '',
        showcase_group: rdata.showcase_group || '',
        resume_json: JSON.stringify(rdata),
      };
    });

    WpAPI.submitShowcaseQueue(user.id, items, showcaseEmail).then(resp => {
      if (mounted.current) {
        if (resp.success) {
          setShowcaseStatus({ submitted: true, count: resp.count, batch_id: resp.batch_id });
        } else {
          setShowcaseStatus({ ...showcaseStatus, error: resp.error || 'Submission failed' });
        }
        setShowcaseLoading(false);
      }
    }).catch(() => {
      if (mounted.current) {
        setShowcaseStatus({ ...showcaseStatus, error: 'Network error submitting queue' });
        setShowcaseLoading(false);
      }
    });
  };

  return (
    <>
      <div className="dashboard-container ">
        <Splash />
        <div className="block">
          {spinner ? (
            <div className="spinner spinner-dashboard">
              <img
                className="loader-img"
                src="{`${APP_DOMAIN}/assets/images/spinner.svg`}"
                alt="loader"
              />
            </div>
          ) : (
            ""
          )}
          <div className='create-btn'>
              <div className="create-new-mobile" onClick={() => {
              // Check resume limit before creating
              if (!canProceedWithResumeAction('create')) {
                return;
              }
              gaTrack('RB App', 'Dashboard', `Create a New ${entityName}`);
              ga4Track('app_dashboard_create_button_mobile', 'RB App', `Create a New ${entityName} Mobile`);
              setCreateAction(true);
            }}>
              <span>+ Create New {entityName}</span>
            </div>
          </div>

          <div className='resume-blocks-container'>
            <ul className={`resume-list ${dashboardEntities.length === 1 ? 'size-template-col-2' : ''}`}>
            {entities === '' ? ( <PageLoader />) : 
              dashboardEntities.length ? dashboardEntities.map((key, index) => {
                let entity = entities[key];
                let fullname =
                  (entity.heading.fname != ""
                    ? entity.heading.fname
                    : `${entityName}_Draft`) +
                    (entity.heading.fname !== "" && entity.heading.lname !== "" ? "_" : "") +
                  entity.heading.lname;
                let rname = (entity.hasOwnProperty('resume_name') && entity.resume_name.length) ?
                  entity.resume_name :
                  fullname.replace(/\s/g, "_");
                if (entityNames.includes(rname)) {
                  //duplicate name found
                  rname = fullname + "_" + index;
                }
                entityNames[key] = rname
                const scorePoint = entity?.resume_review?.resume_score?.total_points;
                const scoreColor = circleColor(scorePoint);
                // console.log(entity);
                return (
                  <li className='resume-list-item' key={key} ref={entityRef} style={entity.bulk_import ? { border: '3px solid #c0392b99', borderRadius: '6px' } : {}}>
                    {!openRows[key] && (<div className='header-column'>
                      <div className='small-template-part' onClick={() => {
                                editEntity(key, entity.active_editor);
                                gaTrack('RB App', 'Dashboard', `Edit ${entityName}`);
                                ga4Track(`app_dashboard_edit_${entityType}`, 'RB App', `Edit ${entityName}`);
                              }} role="button">
                        <div className="single-template">
                          <div className="resume-block">
                            <div className="static-view"
                              >
                              <Resumes data={entity} />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='detail-part'>
                        <div className='title-info'>
                          <span title={rname}>{stringElipse(rname, 14)}</span>
                          <span>Last Modified: {getDateForDisplay(entity.modified_date)}</span>
                        </div>
                      </div>
                      <div className='strength-part'>
                        <div className='strength-box'>
                          <div className='score-resume-info'>
                            <span>Power Score</span>
                            <span className={`score ${!isNaN(scorePoint) && scorePoint === 100 ? 'min-size':''}`} style={{'color':scoreColor,'borderColor':scoreColor}}>{!isNaN(scorePoint) ? scorePoint : <img src={`${APP_DOMAIN}/assets/images/question.svg`} />}</span>
                          </div>
                          <span className='review-link'><ReviewLinkComponent id={key} hasScore={!isNaN(scorePoint)} score = {scorePoint} /></span>
                        </div>
                      </div>
                      {/* <div className='action-btn'>
                          <span onClick={() => {
                            editEntity(key, entity.active_editor);
                            gaTrack('RB App', 'Dashboard', `Edit ${entityName} Icon`)
                            ga4Track(`app_dashboard_edit_${entityType}_icon`, 'RB App', `Edit ${entityName} Icon`);
                          }}><i className='icon-edit-copy'></i>Edit</span>
                          <span onClick={() => checkMembershipAction(download, { [entityType]: entity, key: key, rname: rname })}><i className='icon-download-2'></i> Download</span>

                          <span className='toggel-btn' onClick={() => handleToggle(key)}>
                            <i className={`icon-arrow-${openRows[key] ? 'up' : 'down'}-light`}></i>
                          </span>
                      </div> */}
                      <ActionGroupOne entity={entity} keyValue={key} rname={rname} showLabel={true}/>
                    </div>)}
                    
                    {openRows[key] && (
                      <div className='resume-details'>
                        <div className='large-template-part'>
                          <div className="single-template" key={key} ref={entityRef}>
                            <div className="resume-block">
                                <div className='static-view-container' >
                                  <div className="static-view"
                                    onClick={() => {
                                      editEntity(key, entity.active_editor);
                                      gaTrack('RB App', 'Dashboard', `Edit ${entityName}`);
                                      ga4Track(`app_dashboard_edit_${entityType}`, 'RB App', `Edit ${entityName}`);
                                    }} role="button" style={{cursor:"pointer"}}>
                                    <Resumes data={entity} />
                                  </div>
                                </div>
                                <div className="short-desc">
                                  <div className='information-container'>
                                    <span className='last-modified'>Last Modified: {getDateForDisplay(entity.modified_date)}</span>
                                    <div className='title-information'>
                                      
                                        <span title={rname}>{stringElipse(rname, 14)}</span>
                                        <span  style={{ color: circleColor(scorePoint) }}>Strength: {!isNaN(scorePoint) ? `${scorePoint}%` : <img src={`${APP_DOMAIN}/assets/images/question-purple.svg`} />}</span>
                                      
                                    </div>
                                      {/* <div className='action-btton'>
                                        <span onClick={() => {
                                          editEntity(key, entity.active_editor);
                                          gaTrack('RB App', 'Dashboard', `Edit ${entityName} Icon`)
                                          ga4Track(`app_dashboard_edit_${entityType}_icon`, 'RB App', `Edit ${entityName} Icon`);
                                        }}><i className="icon-edit-copy"></i> <span className='action_edit'>Edit</span></span>

                                        <span onClick={() => checkMembershipAction(download, { [entityType]: entity, key: key, rname: rname })}><i className="icon-download-2"></i><span className='action_download'>Download</span></span>
                                      </div> */}
                                      <ActionGroupOne entity={entity} keyValue={key} rname={rname} showLabel = {false}/>
                                    
                                  </div>

                                </div>
                            </div>
                            <ActionGroupTwo entity={entity} keyValue={key} />
                          </div>
                        </div>
                        <ResumeReviewComponent review = {entity?.resume_review} >
                          <ReviewLinkComponent id={key} hasScore={!isNaN(scorePoint)} score={scorePoint}/>
                        </ResumeReviewComponent>

                        <div className='action-items'>
                          <span className='toggel-btn' onClick={() => handleToggle(key)}>
                            <i className={`icon-arrow-${openRows[key] ? 'up' : 'down'}-light`}></i>
                          </span>
                          <div className='btn-wrapper'>
                            <ReviewLinkComponent id={key} hasScore={!isNaN(scorePoint)}  score={scorePoint}/>
                          </div>
                        </div>
                      </div>
                    )}

                  </li>

                );
              }) : (
                  <NoResumeFound />
                )}
              
            </ul>

          </div>
        </div>
      </div>
      {showLoginPopUp ? <SignUpPopup setShowLoginPopUp={(c) => { setShowLoginPopUp(c) }} setEntities={r => setEntities(r)} /> : ''}

      {showcasePopup && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          background: 'rgba(0,0,0,.45)', zIndex: 9999,
          display: 'flex', alignItems: 'center', justifyContent: 'center'
        }}>
          <div style={{
            background: '#fff', borderRadius: '8px', padding: '24px', maxWidth: '480px',
            width: '90%', position: 'relative', boxShadow: '0 8px 32px rgba(0,0,0,.2)'
          }}>
            <h3 style={{ margin: '0 0 8px', fontSize: '18px' }}>Generate Showcase Resumes</h3>
            <p style={{ color: '#666', fontSize: '13px', margin: '0 0 16px' }}>
              Only bulk imported resumes with label and group can be generated through this feature.
            </p>
            {showcaseLoading && <p>Loading...</p>}
            {showcaseStatus?.submitted && (
              <p style={{ color: '#27ae60', fontWeight: 600 }}>
                {showcaseStatus.count} resume(s) submitted to queue (Batch: {showcaseStatus.batch_id?.substring(0, 8)}...)
              </p>
            )}
            {showcaseStatus?.error && (
              <p style={{ color: '#e74c3c' }}>{showcaseStatus.error}</p>
            )}
            {!showcaseLoading && showcaseStatus?.success && !showcaseStatus?.submitted && (
              <>
                {showcaseStatus.count > 0 ? (
                  <>
                    <p style={{ fontSize: '14px', marginBottom: '12px' }}>
                      <strong>{showcaseStatus.count}</strong> eligible resume(s) found.
                      {showcaseStatus.already_showcase > 0 && <span> ({showcaseStatus.already_showcase} already have showcase.)</span>}
                      {showcaseStatus.already_queued > 0 && <span> ({showcaseStatus.already_queued} already queued.)</span>}
                    </p>
                    <label style={{ fontSize: '13px', fontWeight: 600 }}>Notification email</label>
                    <input
                      type="email"
                      value={showcaseEmail}
                      onChange={e => setShowcaseEmail(e.target.value)}
                      style={{
                        width: '100%', padding: '8px 12px', border: '1px solid #ddd',
                        borderRadius: '4px', marginBottom: '12px', fontSize: '14px', boxSizing: 'border-box'
                      }}
                    />
                    <button
                      onClick={submitShowcaseQueue}
                      disabled={!showcaseEmail}
                      style={{
                        background: '#2c3e50', color: '#fff', border: 'none', padding: '10px 24px',
                        borderRadius: '4px', cursor: 'pointer', fontSize: '14px', fontWeight: 600
                      }}
                    >
                      Submit {showcaseStatus.count} to Queue
                    </button>
                  </>
                ) : (
                  <p style={{ fontSize: '14px' }}>
                    {showcaseStatus.already_showcase > 0 || showcaseStatus.already_queued > 0
                      ? 'All eligible resumes already have showcase or are queued for processing.'
                      : 'No eligible resumes found. Only bulk imported resumes with a label and group qualify.'}
                  </p>
                )}
              </>
            )}

            <button onClick={() => setShowcasePopup(false)}
              style={{
                position: 'absolute', top: '12px', right: '12px', background: 'none',
                border: 'none', fontSize: '20px', cursor: 'pointer', color: '#999'
              }}>×</button>
          </div>
        </div>
      )}
    </>
  );
}

export default ResumesListing;